var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex align-items-center",class:[_vm.align]},[(_vm.buttonText && _vm.buttonPath)?_c('Button',{attrs:{"size":_vm.size,"to":_vm.buttonPath,"blank":_vm.buttonBlank}},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }